import React from "react";
import { Link, useLocation } from "react-router-dom";
import bookmark from "../../assets/images/bookmarkfff.png";
import groceries from "../../assets/images/groceriesfff.png";
import bill from "../../assets/images/billfff.png";
import delivery from "../../assets/images/deliveryfff.png";
import { useTranslation } from "react-i18next";
import CartLink from "./Cart";
import { useAuth } from "../../hooks/customers/AuthProvider";
import * as Config from "../../config/config";

function Footer() {
  const { t } = useTranslation();
  const location = useLocation();
  const auth = useAuth();
  const customer = auth?.customer;
  //const cart = useSelector((state) => state.cart.cartData);
  const isActive = (path) => (location.pathname === path ? "active" : "");
  //console.log('cart',cart);
  return (
    <ul>
      {customer?.role != Config.DISTRICT_MANAGER_ROLE && (
        <>
          <li>
            <Link to="/favourites" className={isActive("/favourites")}>
              <img src={bookmark} alt="" width="24" height="37" />
              <p className={`favs ${isActive("/favourites")}`}>{t("favs")}</p>
            </Link>
          </li>
          <li>
            <Link to="/menu" className={isActive("/menu")}>
              <img src={groceries} alt="" width="37" height="37" />
              <p className={`menu ${isActive("/menu")}`}>{t("menu")}</p>
            </Link>
          </li>
          <li>
            <CartLink />
          </li>
          <li>
            <Link to="/bill" className={isActive("/bill")}>
              <img src={bill} alt="" width="31" height="35" />
              <p className={`order ${isActive("/bill")}`}>{t("order")}</p>
            </Link>
          </li>
          <li>
            <Link to="/delivered" className={isActive("/delivered")}>
              <img src={delivery} alt="" width="43" height="33" />
              <p className={`delivered ${isActive("/delivery")}`}>
                {t("delivered")}
              </p>
            </Link>
          </li>
        </>
      )}
      {customer?.role == Config.DISTRICT_MANAGER_ROLE && (
        <li>
          <Link
            to="/district-manager/pending-orders"
            className={
              location.pathname === "/district-manager/pending-orders"
                ? "active"
                : ""
            }
          >
            <img src={delivery} alt="" width="43" height="33" />
            <p
              className={`delivered ${isActive(
                "/district-manager/pending-orders"
              )}`}
            >
              {t("order_approvals")}
            </p>
          </Link>
        </li>
      )}
    </ul>
  );
}

export default Footer;
